<template>
	<v-container class="pa-0" fluid>
		<el-overlay-loading :loading="pageloading" />
		<!-- title  -->
		<h1 class="mb-1">{{ $t('Redaguoti JAR faktą su iPasas vaidmeniu') }}</h1>
		<v-card outlined class="mb-4">
			<form @keydown.enter.prevent="submit()">

				<v-card-text class="mt-5">
					<el-autocomplete :items="availableJarFacts" itemvalue="value" itemtext="text" label="JAR faktas"
						tooltip="Ireg. Pagrindinis. Dokumentai. Siunčiamų dokumentų žurnalas. Siuntimo būdas" multiple
						v-model="selectedJarFacts" />
					<!-- add button  -->
					<el-button class="mb-5" color="primary" icon="pridėti" title="Pridėti faktus" :loading="loading"
						@click.native.stop="addItems()" />
					<!-- search -->
					<jar-fact-ipas-role-search :loading="loading" :jarFacts="jarFacts" :jarIpasasRoles="jarIpasasRoles" @search="searchList" />
					
					<v-card v-for="(jarfact, index) in filterItemList" :key="index" class="mb-2 bg-white border">
						<v-card-text class="white d-flex justify-space-between">
							<div>
								{{ getFactTitle(jarfact) }}
							</div>
							<div>
								<v-icon dense class="mx-1" @click="openDeleteForm(jarfact)">mdi-delete-outline</v-icon>
			
								<v-icon v-if="!expandedForms.includes(`${jarfact.jar_fact}-${jarfact.jar_fact_sub_type}`)"
									@click="showFacts(jarfact)">mdi-chevron-right</v-icon>
								<v-icon v-else @click="hideFacts(jarfact)">mdi-chevron-down</v-icon>
							</div>
						</v-card-text>
						<v-card-text class="px-0 py-0" v-if="expandedForms.includes(`${jarfact.jar_fact}-${jarfact.jar_fact_sub_type}`)">
							<el-select-table title="iPasas vaidmenys" :elKey="`${jarfact.jar_fact}-${jarfact.jar_fact_sub_type}`"
								:available-items="jarIpasasRoles['lt']" :selected-items="jarfact.ipas_roles"
								availableTitle="Galimos iPasas  vaidmenų reikšmės" selectedTitle="Pasirinktos iPasas vaidmenų reikšmės"
								item-key="code" item-name="text" @move-to-selected="moveToSelected" @move-to-available="moveToAvailable" />
						</v-card-text>
					</v-card>

					<v-card-text v-if="filterItemList.length === 0" class="text-center">
						Nėra duomenų
					</v-card-text>
				</v-card-text>
				<v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="confirmResetForm()"
              :loading="loading"
            />
            <el-button
              title="Išsaugoti"
              :loading="loading"
              @click.native="saveData()"
              color="primary"
              icon="išsaugoti"
            />
          </v-row>
        </v-card-actions>
			</form>
		</v-card>


		<modal-delete title="Šalinti įrašą" text="Ar tikrai norite pašalinti įrašą?" v-model="showDelete" :loading="loading"
			:item="modalDeleteItem" @confirmDelete="confirmDelete" />

		<modal-delete
			v-model="showConfirmResetForm"
			:loading="loading"
			title="Atšaukti pakeitimus"
			text="Ar tikrai norite atšaukti pakeitimus?"
			@confirmDelete="resetForm()"
		/>
	</v-container>
</template>

<script>
import userRole from '@/mixins/userRole'
import ModalDelete from '@/components/modals/ModalDelete'
import tableParameters from '@/mixins/tableParameters'
import JarFactIpasRoleSearch from './JarFactIpasRoleSearch'

export default {
	name: 'JarFactIpasRolesIndex',
	components: {
		ModalDelete,
		JarFactIpasRoleSearch
	},
	mixins: [userRole, tableParameters],
	data() {
		return {
			pageloading: true,
			loading: false,
			paginationloading: false,
			search: null,
			showDelete: false,
			modalDeleteItem: null,
			itemsToDelete: [],
			listData: [],
			showConfirmResetForm: false,
			itemsPerPageOptions: [10, 50, 100],
			pagination: {
				page: 1,
				pageSize: 10,
				total: 10,
				totalPages: 0,
				sort: null,
				sortDesc: [],
				direction: 'asc',
			},
			jarFacts: { lt: [], en: [] },
			jarIpasasRoles: { lt: [], en: [] },
			searchData: {
				"jar_fact_sub_type_id-search-in": [],
				"kada_jar_role_id-search-custom": [],
			},
			selectedJarFacts: [],
			expandedForms: [],
		}
	},
	computed: {
		headers() {
			return [
				{
					text: this.$t('Veiksmai'),
					align: 'center',
					sortable: false,
					value: 'actions',
				},
				{
					text: this.$t('Kodas'),
					align: 'start',
					value: 'code',
				},
				{
					text: this.$t('Pavadinimas LT'),
					align: 'start',
					value: 'title_lt',
				},
				{
					text: this.$t('Pavadinimas EN'),
					align: 'start',
					value: 'title_en',
				},
			]
		},

		filteredHeader() {
			return this.headers.filter((item) => {
				return !item.hide
			})
		},

		filterItemList() {
			let tempList = this.listData.filter((item) => {
				const factTypeSearch = this.searchData["jar_fact_sub_type_id-search-in"] || []
				let rolesMatch = true
				if (this.searchData["kada_jar_role_id-search-custom"]?.length > 0) {
					this.searchData["kada_jar_role_id-search-custom"]?.forEach(role => {

						if (!item.ipas_roles.includes(String(role))) {
							rolesMatch = false
						}
					})
				}

				return ((factTypeSearch.length > 0 && factTypeSearch.includes(`${item.jar_fact}-${item.jar_fact_sub_type}`)) || factTypeSearch.length === 0)
					&& rolesMatch
			})

			// Sort by jar_fact (number), then by jar_fact_sub_type (number)
			return tempList.sort((a, b) => {
				const jarFactA = parseInt(a.jar_fact) || 0
				const jarFactB = parseInt(b.jar_fact) || 0
				
				if (jarFactA !== jarFactB) {
					return jarFactA - jarFactB
				}
				
				// If jar_fact is the same, sort by jar_fact_sub_type
				const subTypeA = parseInt(a.jar_fact_sub_type) || 0
				const subTypeB = parseInt(b.jar_fact_sub_type) || 0
				return subTypeA - subTypeB
			})
		},
		hideFooter() {
			return this.pagination.total <= 10
		},
		availableJarFacts() {
			if (!this.jarFacts.lt || !Array.isArray(this.jarFacts.lt)) {
				return []
			}

			const availableJarFacts = {
				lt: this.jarFacts.lt.filter(jarFact => {
					return !this.listData.some(listItem =>
						listItem.jar_fact === jarFact.jar_fact_type_code &&
						listItem.jar_fact_sub_type === jarFact.code
					)
				}),
				en: []
			}
			// Filter out JAR facts that are already in the list
			return availableJarFacts
		},
	},
	beforeDestroy() {

	},
	created() {
		this.getClassifiers()
		this.getData()
	},
	methods: {
		showFacts(jarfact) {
			this.expandedForms.push(`${jarfact.jar_fact}-${jarfact.jar_fact_sub_type}`)
		},
		hideFacts(jarfact) {
			this.expandedForms = this.expandedForms.filter(item => item !== `${jarfact.jar_fact}-${jarfact.jar_fact_sub_type}`)
		},
		moveToSelected(item, elKey) {
			const jarFact = this.listData.find(jarFact => `${jarFact.jar_fact}-${jarFact.jar_fact_sub_type}` === elKey)
			if (jarFact) {
				jarFact.ipas_roles.push(item.code)
				jarFact.ipas_roles.sort((a, b) => a - b)
			}
		},
		moveToAvailable(item, elKey) {
			const jarFact = this.listData.find(jarFact => `${jarFact.jar_fact}-${jarFact.jar_fact_sub_type}` === elKey)
			if (jarFact) {
				jarFact.ipas_roles = jarFact.ipas_roles.filter(role => role !== item.code)
			}
		},
		searchList(searchData) {
			this.searchData = searchData
			this.loading = false
			// this.getData(searchData.btn)
		},
		getFactTitle(jarFact) {
			return `(${jarFact.jar_fact}, ${jarFact.jar_fact_sub_type}) ${jarFact.title_lt}`
		},
		getClassifiers() {
			this.pageloading = true
			let requiredClassifiers = { classifiers: ['jar-fact-sub-type', 'kada-jar-role'] }
			this.$axios
				.post(`classifiers`, requiredClassifiers)
				.then((res) => {
					this.jarFacts['lt'] = res.data.classifiers['jar-fact-sub-type']['lt']
					this.jarIpasasRoles['lt'] = res.data.classifiers['kada-jar-role']['lt']
				})
				.catch((err) => {
					this.$root.$emit('DATA_ERROR', err)
				})
				.finally(() => {
					this.pageloading = false
				})
		},
		getData(resetPageNr = false) {
			this.setSortParams()

			const data = {
				search: this.searchData,
			}

			return this.$axios
				.post(`jar-fact-ipas-roles/list`, data)
				.then((res) => {
					this.listData = res.data.jarFactIpasRoles
				})
				.catch((err) => {
					this.$root.$emit('DATA_ERROR', err)
				})
				.finally(() => {
					this.loading = false
					this.pageloading = false
				})
		},
		confirmResetForm() {
			this.showConfirmResetForm = true
		},
		async resetForm() {
			this.pageloading = true
			await this.getData()
			this.showConfirmResetForm = false
			this.pageloading = false
		},
		addItems(items) {
			const factsToAdd = this.jarFacts.lt.filter(item => this.selectedJarFacts.includes(item.value))
			factsToAdd.forEach(item => {
				// Check if it doesn't already exist in the list
				const exists = this.listData.some(existingItem =>
					existingItem.jar_fact === item.jar_fact_type_code &&
					existingItem.jar_fact_sub_type === item.code
				)
				if (!exists) {
					this.listData.push({
						jar_fact: item.jar_fact_type_code,
						jar_fact_sub_type: item.code,
						title_lt: item.title,
						ipas_roles: []
					})
				}
			})
			this.selectedJarFacts = []
		},
		saveData() {
			this.loading = true
			const facts = this.listData.map(item => ({
				jar_fact: item.jar_fact,
				jar_fact_sub_type: item.jar_fact_sub_type,
				ipas_roles: item.ipas_roles
			}))

			this.$axios
				.post(`jar-fact-ipas-roles/update`, { facts: facts, facts_delete: this.itemsToDelete})
				.then((res) => {
					this.$root.$emit('DATA_OK_CODE', '000110')
					this.listData = res.data.jarFactIpasRoles
				})
				.catch((err) => {
					this.$root.$emit('DATA_ERROR', err)
				})
				.finally(() => {
					this.loading = false
				})
		},
		openDeleteForm(item) {
			this.modalDeleteItem = item
			this.showDelete = true
		},
		confirmDelete() {
			if (this.modalDeleteItem.id) {
				this.itemsToDelete.push(this.modalDeleteItem.id)
				this.listData = this.listData.filter(item => `${item.jar_fact}-${item.jar_fact_sub_type}` !== `${this.modalDeleteItem.jar_fact}-${this.modalDeleteItem.jar_fact_sub_type}`)
			} else {
				this.listData = this.listData.filter(item => `${item.jar_fact}-${item.jar_fact_sub_type}` !== `${this.modalDeleteItem.jar_fact}-${this.modalDeleteItem.jar_fact_sub_type}`)
			}
			this.modalDeleteItem = null
			this.showDelete = false
		},
	},
}
</script>
<style lang="scss" scoped>
.potipis {
	background: #8eb693;

	.v-card__text {
		&.active {
			background: #2c7837;
			color: #fff;
		}
	}
}

.tikrina-chip {
	max-width: 110px;
}
</style>